<template>
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row style="display: flex">
          <el-col :span="3">
            <el-form-item>
              <el-input
                style="width: 140px; margin-right: 5px"
                placeholder="请输入顾客名称或手机号"
                clearable
                v-model="search.keyword"
                @keyup.enter.native="clickSearch"
                size="small"
              ></el-input>
              <!-- <el-button @click="clickSearch" type="warning" size="small">搜索</el-button> -->
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="门店" label-width="40px">
              <el-select
                style="width: 100px"
                class="select"
                v-model="search.shop_id"
                placeholder="请选择"
                clearable
                @change="clickSearch"
                size="small"
              >
                <el-option
                  v-for="item in shopsList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="是否为会员" label-width="90px">
              <el-select
                style="width: 80px"
                class="select"
                v-model="search.open_card"
                placeholder="请选择"
                @change="clickSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { value: -1, label: '不限' },
                    { value: 1, label: '是' },
                    { value: 0, label: '否' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item label="宠物类别" :label-width="'70px'">
              <el-select
                style="width: 80px"
                class="select"
                v-model="search.class_name"
                placeholder="请选择"
                @change="clickSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { value: '', label: '不限' },
                    { value: '2', label: '犬类' },
                    { value: '1', label: '猫类' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="会员性别" :label-width="'70px'">
              <el-select
                style="width: 80px"
                class="select"
                v-model="search.sex"
                placeholder="请选择"
                @change="clickSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { value: -1, label: '全部' },
                    { value: 0, label: '女' },
                    { value: 1, label: '男' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="2">
            <resetBtn
              @reset="reset"
              style="width: 56px; display: inline-block; margin: 3px 10px"
            ></resetBtn>
            <el-button
              @click="$router.push({ path: '/huiyuan/huiyuanAdd' })"
              type="warning"
              size="small"
              >新建</el-button
            >
          </el-col>
          <el-col :span="3" style="margin-top: 6px">
            <el-form-item label="会员类型">
              <el-select
                v-model="type"
                size="small"
                placeholder="请选择"
                style="width: 110px"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: '' },
                    { label: '有余额', value: '1' },
                    { label: '没有余额', value: '2' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button
            v-if="$buttonAuthority('huiyuan-exportUser')"
              :disabled="exportDisabled"
              type="warning"
              size="small"
              style="margin-top: 10px"
              @click="exportUserList"
              >导出顾客列表</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- <tabLine :tabList="['全部']" @change="changeTabNav"></tabLine> -->
    <div class="pageConBox" v-if="tableData.length > 0">
      <el-table :data="tableData" style="width: 100%">
        <!-- <el-table-column fixed label="序号" width="70">
					<template slot-scope="scope">
						{{scope.$index+1}}
					</template>
				</el-table-column> -->
        <el-table-column label="姓名" min-width="160">
          <template slot-scope="scope" >
            <span
              style="cursor: pointer; color: #409eff"
              @click="
                $router.push({
                  path: '/huiyuan/huiyuanSee',
                  query: { id: scope.row._id },
                })
              "
            >
              <img
              v-if="scope.row.club_card.is_valid==true"
                style="width: 26px; padding-right: 6px; vertical-align: bottom"
                src="../../../assets/img/hyIcon.png"
              />
              {{ scope.row.basic_info.nick_name }}
              <span
                v-if="scope.row.lifeLong && scope.row.lifeLong.status === 1"
              >
                <el-tooltip
                  effect="dark"
                  :content="scope.row.lifeLong.remark"
                  placement="top-start"
                >
                  <img
                    style="height: 16px; cursor: pointer"
                    src="../../../assets/img/zhong.png"
                  />
                </el-tooltip>
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="电话" min-width="110">
          <template slot-scope="scope">                                                                              
            {{ scope.row.basic_info.user_mobile }}
          </template>
        </el-table-column>
        <el-table-column label="购宠情况" min-width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.buyPetBackInfo.status === 1">新手首购</span>
            <span v-if="scope.row.buyPetBackInfo.status === 2">有宠首购</span>
            <span v-if="scope.row.buyPetBackInfo.status === 3">花生复购</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" min-width="60">
          <template slot-scope="scope">
            {{ scope.row.basic_info.sex }}
          </template>
        </el-table-column>
        <el-table-column label="宠物" min-width="180">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.pets_info"
              :key="index"
              @click="
                $router.push({
                  path: '/huiyuan/huiyuanPetSee',
                  query: { uid: scope.row._id, pid: item._id },
                })
              "
            >
              <img
                v-if="item.hs_pet"
                style="
                  width: 30px;
                  padding-right: 6px;
                  vertical-align: text-bottom;
                "
                src="../../../assets/img/vip_pet.png"
              />
              <span style="color: #409eff; cursor: pointer">{{
                item.nick_name
              }}</span>
              ({{ item.category_info.name }})
            </div>
          </template>
        </el-table-column>
        <el-table-column label="余额" min-width="90">
          <template slot-scope="scope">
            {{
              scope.row.card_info.user_yue > 0
                ? scope.row.card_info.user_yue.toFixed(2)
                : 0
            }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="赠额" min-width="70">
					<template slot-scope="scope">
						{{scope.row.card_info.user_zenge>0?(scope.row.card_info.user_zenge).toFixed(2):0}}
					</template>
				</el-table-column> -->
        <el-table-column label="总额(余+赠)" min-width="100">
          <template slot-scope="scope">
            {{
              (
                scope.row.card_info.user_yue + scope.row.card_info.user_zenge
              ).toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column label="押金" min-width="70">
          <template slot-scope="scope">
            {{ scope.row.card_info.user_yajin }}
          </template>
        </el-table-column>
        <el-table-column label="注册地" min-width="100">
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.operation_info &&
                scope.row.operation_info.create.create_from == 'xcx'
              "
              >花生宠物小程序</span
            >
            <span v-else>{{ scope.row.company_info.shop_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员剩余天数" min-width="150">
					<template slot-scope="props" v-if="props.row.club_card">
						<div>{{props.row.club_card.surplus_day}}</div>
					</template>
				</el-table-column>
        <el-table-column label="注册时间" min-width="150">
          <template slot-scope="scope">
            {{
              scope.row.operation_info &&
              $public.FTime(scope.row.operation_info.create.create_time)
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.pets_info.length > 0"
              @click="toShouyin(scope.row)"
              type="text"
              size="small"
              >去下单</el-button
            >
            <el-button
              @click="
                $router.push({
                  path: '/huiyuan/huiyuanSee',
                  query: { id: scope.row._id },
                })
              "
              type="text"
              size="small"
              >查看</el-button
            >
            <!-- <el-button @click="$router.push({path:'/huiyuan/huiyuanEdit',query:{id:scope.row._id}})" type="warning" size="small">编辑</el-button> -->
            <!-- <el-button @click="del(scope.row)" type="danger" size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <page
        style="padding: 10px 0"
        :page="page.page"
        :total="page.total"
        @change="changePage"
      ></page>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import page from "../../../components/page.vue";
import resetBtn from "../../../components/resetBtn.vue";
export default {
  components: { page, resetBtn },
  data() {
    return {
      exportDisabled: false,
      // 会员余额
      type: "",
      show: false,
      shopsList: this.$store.getters.shopList,
      search: {
        shop_id: "", //门店id
        open_card: -1, //花生会员：0否；1是；-1不限
        hs_pet: -1, //花生宠物：0否；1是；-1不限
        class_name: "", //类别 1：犬类；2：猫类
        field: "", //搜索对象:顾客：member;宠物：pet
        sex: -1,
        keyword: "",
      },
      tableData: [],
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    saleList() {
      return this.$store.state.mendian.saleList;
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 导出顾客列表
    exportUserList() {
      this.exportDisabled = true;
      let params = {
        type: this.type,
      };
      let loading = this.$loading();
      axios
        .get(
          process.env.VUE_APP_Url_member + "/api/middleware/Member/exportList",
          {
            params,
            responseType: "blob",
          }
        )
        .then((response) => {
          loading.close();
          console.log(response.data, "地址---");
          var href = window.URL.createObjectURL(response.data); //创建下载的链接
          var downloadElement = document.createElement("a");
          downloadElement.href = href;
          downloadElement.download = "顾客列表导出.xlsx";
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.type = "";
          this.exportDisabled = false;
        });
    },
    // 去下单
    toShouyin(row) {
      if (this.saleList.length > 0) {
        this.$message({
          message: "有客户占用工作台，请前往挂单",
          type: "error",
        });
        // this.valueVip = ''
        console.log("有客户占用工作台");
        return;
      } else {
        this.$router.push({ path: "/mendian/shouyin" });
        this.$store.commit("mendian/set_isSanke", false);
        this.$store.commit("mendian/set_userInfo", row);
        this.$store.commit("mendian/set_curPetId", row.pets_info[0]?row.pets_info[0]._id:'');
      }
    },
    // 重置筛选
    reset() {
      this.page.page = 1;
      this.search.keyword = "";
      this.search.shop_id = "";
      this.search.open_card = -1;
      this.search.hs_pet = -1;
      this.search.class_name = "";
      this.search.field = "";
      this.search.sex = -1;
      this.getTableData();
    },
    // 改变筛选条件
    clickSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 页码改变
    changePage(a) {
      this.page.page = a;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      let hs_pet = -1;
      let buyBackStatus = -1;
      if (this.search.hs_pet === 0) {
        hs_pet = 0;
        buyBackStatus = 0;
      } else if (this.search.hs_pet === 1) {
        hs_pet = 1;
        buyBackStatus = 1;
      } else if (this.search.hs_pet === 2) {
        hs_pet = 1;
        buyBackStatus = 2;
      } else if (this.search.hs_pet === 3) {
        hs_pet = 1;
        buyBackStatus = 3;
      }
      let params = {
        shop_id: this.search.shop_id, //门店id
        open_card: this.search.open_card, //花生会员：0否；1是；-1不限
        hs_pet: hs_pet, //花生宠物：0否；1是；-1不限
        class_name: this.search.class_name, //类别  '' 犬类； 猫类
        field: "", //搜索对象:顾客：member;宠物：pet
        sex: this.search.sex, //   -1：全部、 0：女、1：男
        buyBackStatus: buyBackStatus, // 1.新手宠物主,首次购买花生宠物 2.有养宠物购买了第一只花生宠物 3.购买花生宠物后再次,复购花生宠物
        keyword: this.search.keyword, //关键字
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        staff_type: "1,2,3"
      };
      let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_Url_member+"/api/middleware/Member/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          console.log("顾客",res);
          this.tableData = res.data.data || [];
          this.page.total = res.data.count;
        }
      });
    },
    // 删除
    // del(row) {
    // 	this.$confirm('确定要删除?', '提示', {
    // 		confirmButtonText: '确定',
    // 		cancelButtonText: '取消',
    // 		type: 'warning'
    // 	}).then(() => {
    // 		let params = {
    // 			id: row._id
    // 		}
    // 		this.$http.get('/api/Member/Delete', params).then(res => {
    // 			if (res.code == 0) {
    // 				this.getTableData();
    // 				this.$message({
    // 					message: '删除成功',
    // 					type: 'success'
    // 				});
    // 			}
    // 		})
    // 	})
    // }
  },
};
</script>
<style scoped lang="scss">
.page {
  .searchBox {
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        padding-right: 5px;
      }
    }
  }
  .pageConBox {
    padding: 0 0px;
    min-height: 600px;
    margin-top: 10px;
  }
}
</style>
